
import frag from 'vue-frag';

export default {
  directives: { frag },
  computed: {
    utmSource() {
      return this.$route.query.utm_source;
    },
    utmCampaign() {
      return this.$route.query.utm_campaign;
    },
    utmMedium() {
      return this.$route.query.utm_medium;
    },
    url() {
      const utm = {
        utm_source: this.utmSource,
        utm_campaign: this.utmCampaign,
        utm_medium: this.utmMedium,
      };
      const params = this.formatParams(utm);

      if (params.length) {
        return `/plus?${params.join('&')}`;
      }

      return '/plus';
    },
    join() {
      const utm = {
        utm_source: this.utmSource,
        utm_campaign: this.utmCampaign,
        utm_medium: this.utmMedium,
      };
      const params = this.formatParams(utm);

      if (params.length) {
        return `/products/plus-2019/buy/?${params.join('&')}`;
      }

      return '/products/plus-2019/buy/';
    },
  },
  methods: {
    formatParams(utmObj) {
      return Object.entries(utmObj).reduce((m, [k, v]) => {
        if (v) {
          m.push(`${k}=${v}`);
        }

        return m;
      }, []);
    },
  },
};
